import React from "react";
import { Modal, RadioGroup, Spinner } from "react-rainbow-components";
import { FiPlus } from "react-icons/fi";
import { uploadImageReturnUrl } from "../../functions/storage";
import styled from "styled-components";
import {
  ButtonContainer,
  ButtonCreateAdmin,
  ImageSelected,
  InputAdmin,
  Title,
} from "../common/FormComponent";
import { createAdmin } from "../../services/admin.service";

import { useError } from "../../store/ErrorModal";
interface IProps {
  isOpen: boolean;
  setIsOpen: (v: boolean) => void;
  fetchData: () => Promise<void>;
}
export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  width: 100%;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  color: #8c8c8c;
`;
export default function CreateAdminModal(props: IProps) {
  const [data, setData] = React.useState<{ [key: string]: any }>({});
  const [valueGroupButton, setValueGroupButton] = React.useState<string>();
  const [blobImage, setBlobImage] = React.useState<File>();
  const [image, setImage] = React.useState<any>();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const fileInput = React.useRef<any>();
  const { onError } = useError();
  const InputClick = () => {
    fileInput.current.click();
  };
  const handleFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileUploaded = event.currentTarget.files;
    if (!fileUploaded) return;
    const imageAsFile = fileUploaded[0];
    setBlobImage(imageAsFile);
    let reader = new FileReader();
    reader.readAsDataURL(imageAsFile);
    reader.onload = () => {
      setImage(reader.result);
    };
  };

  const options = [
    { value: "admin", label: "ผู้ดูแลระบบ" },
    { value: "doctor", label: "หมอ" },
    { value: "operator", label: "พนักงานขาย" },
  ];

  const handleChangeData = (key: string, value: string) => {
    const nData = data;
    nData[key] = value;
    return setData(nData);
  };

  const handleClickSubmit = async () => {
    if (isLoading) return;
    setIsLoading(true);
    const dataUser: { [key: string]: any } = {
      ...data,
    };
    const phone: string = data.phone;

    if (!blobImage) {
      setIsLoading(false);
      return onError("กรุณาเพิ่มรูป");
    }

    if (
      !dataUser.phone ||
      !dataUser.firstName ||
      !dataUser.lastName ||
      !dataUser.displayName ||
      !dataUser.username ||
      !dataUser.role ||
      !dataUser.email ||
      !dataUser.password ||
      !dataUser.confirmPassword
    ) {
      setIsLoading(false);
      return onError("กรุณากรอกข้อมูลให้ครบทุกช่อง");
    }
    if (phone.length === 10 && phone[0] === "0")
      dataUser["phone"] = "+66" + phone.slice(1);
    if (phone.length !== 9) {
      setIsLoading(false);
      return onError("กรุณาใส่หมายเลขโทรศัพท์ให้ถูกต้อง");
    } else dataUser["phone"] = "+66" + phone;

    try {
      const urlImage = blobImage
        ? await uploadImageReturnUrl(blobImage, `/admin/${dataUser.username}/`)
        : undefined;
      dataUser["imageUrl"] = urlImage;
      delete dataUser.blobImage;
      Object.keys(dataUser).forEach(
        (key) => dataUser[key] === undefined && delete dataUser[key]
      );
      await createAdmin(dataUser);
      setIsLoading(false);
      props.fetchData();
      props.setIsOpen(false);
    } catch (error: any) {
      setIsLoading(false);
      onError(error as any);
    }
  };

  return (
    <Modal
      hideCloseButton
      isOpen={props.isOpen}
      onRequestClose={() => props.setIsOpen(false)}
      style={{ padding: "1rem" }}
    >
      <Container>
        <Title>เพิ่ม Admin</Title>
        <div onClick={InputClick} style={{ alignSelf: "center" }}>
          <input
            type="file"
            ref={fileInput}
            accept="image/*"
            onChange={handleFile}
            style={{ display: "none", alignSelf: "center" }}
          />
          {image ? <ImageSelected src={image} alt="profile" /> : <IconPlus />}
        </div>
      </Container>
      <Container>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            padding: "2rem",
            maxWidth: "30rem",
            alignSelf: "center",
          }}
          className="rainbow-align-content_center rainbow-m-vertical_x-large rainbow-flex_wrap"
        >
          <Label>Username:</Label>
          <InputAdmin
            placeholder="username"
            style={{ width: "100%" }}
            onChange={(e) =>
              handleChangeData("username", e.target.value.toLowerCase())
            }
          />
          <Label>ชื่อในไลน์</Label>
          <InputAdmin
            placeholder="ชื่อในไลน์"
            style={{ width: "100%" }}
            onChange={(e) => handleChangeData("displayName", e.target.value)}
          />
          <Label>อีเมล:</Label>
          <InputAdmin
            placeholder="อีเมล"
            style={{ width: "100%" }}
            type="email"
            onChange={(e) => handleChangeData("email", e.target.value)}
          />
          <Label>รหัสผ่าน:</Label>
          <InputAdmin
            placeholder="รหัสผ่าน"
            type="password"
            onChange={(e) => handleChangeData("password", e.target.value)}
            style={{ width: "100%" }}
          />
          <Label>ยืนยันรหัสผ่าน:</Label>
          <InputAdmin
            placeholder="ยืนยันรหัสผ่าน"
            onChange={(e) =>
              handleChangeData("confirmPassword", e.target.value)
            }
            type="password"
            style={{ width: "100%" }}
          />

          <Label style={{ width: "53%" }}>ชื่อ:</Label>
          <Label style={{ width: "47%" }}>นามสกุล:</Label>

          <InputAdmin
            placeholder="ชื่อ"
            style={{ width: "49%" }}
            onChange={(e) => handleChangeData("firstName", e.target.value)}
          />
          <InputAdmin
            placeholder="นามสกุล"
            style={{ width: "49%" }}
            onChange={(e) => handleChangeData("lastName", e.target.value)}
          />
          <Label style={{ width: "100%" }}>เบอร์โทร:</Label>
          <div
            style={{
              verticalAlign: "middle",
              alignSelf: "center",
              marginBottom: "0.5rem",
            }}
          >
            +66
          </div>
          <InputAdmin
            placeholder="เบอร์โทร"
            style={{ width: "92%" }}
            onChange={(e) => handleChangeData("phone", e.target.value)}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flex: 1,
              flexWrap: "wrap",
              paddingTop: "1rem",
            }}
          >
            <RadioGroup
              id="radio-group-component-1"
              options={options}
              value={valueGroupButton}
              onChange={(e) => {
                handleChangeData("role", e.target.value);
                setValueGroupButton(e.target.value);
              }}
              orientation="horizontal"
            />
          </div>
        </div>
        <ButtonContainer>
          {isLoading ? (
            <Spinner />
          ) : (
            <ButtonCreateAdmin
              onClick={handleClickSubmit}
              value={"เพิ่ม Admin +"}
            />
          )}
        </ButtonContainer>
      </Container>
    </Modal>
  );
}

const IconPlus = () => (
  <div
    style={{
      width: "8rem",
      height: "8rem",
      borderRadius: "9999px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#F0F0F0",
      alignSelf: "center",
    }}
  >
    <FiPlus color="#fff" size={100} />
  </div>
);
